<template>
    <div class="card assets-offline-map-summary">

        <header class="card-header has-background-light">
            <p class="card-header-title has-text-dark">ASSETS SUMMARY</p>
            <div class="buttons">
                <slot name="headerButtons" />
            </div>
        </header>

        <div class="card-content scrollable" :style="{ height: `${height}px` }">
          
          <slot name="contentTop" />

            <b-table :data="summary.data" striped :loading="loading" style="table-layout:fixed; position: relative">

                <template slot-scope="props">
                    <b-table-column field="name" label="Name" style="overflow-x:hidden;white-space:nowrap;text-overflow:ellipsis;">
                        <template slot="header">Type</template>
                        <swatches colors="text-advanced"
                          :value="getColor(props.row.code)"
                          :trigger-style="{ width: '20px', height: '30px', 'border-radius': '0px' }"
                          :style="{ display: 'inline-block', 'vertical-align': 'middle', position: 'inherit' }"
                          :disabled="!canManageAssets"
                          @input="color => changeColor(props.row, color)"
                        />
                        {{ props.row.name }}
                    </b-table-column>
                    <b-table-column field="valid" label="Valid" class="has-text-right">
                        <template slot="header">Valid</template>
                        {{ props.row.total.valid }}
                    </b-table-column>
                    <b-table-column field="invalid" label="Invalid" class="has-text-right">
                        <template slot="header">Invalid</template>
                        {{ props.row.total.invalid }}
                    </b-table-column>
                    <b-table-column field="total" label="Total" class="has-text-right">
                        <template slot="header">Total</template>
                        {{ props.row.total.total }}
                    </b-table-column>
                </template>

                <template slot="footer">
                    <th class="has-background-dark has-text-light">Total</th>
                    <th class="has-background-dark has-text-light has-text-right">{{ summary.total.valid }}</th>
                    <th class="has-background-dark has-text-light has-text-right">{{ summary.total.invalid }}</th>
                    <th class="has-background-dark has-text-light has-text-right">{{ summary.total.total }}</th>
                </template>

            </b-table>
        </div>

    </div>
</template>

<script>

    import Swatches from "vue-swatches";
    import "vue-swatches/dist/vue-swatches.min.css"
    import { AssetService } from "@/services/asset.service";
    import { CodeService } from "@/services/code.service";

    export default {
      assetService: AssetService,
      codeService: CodeService,
      props: {
        mapHeight: {
          type: Number,
          default: 500
        },
        colors: {
          type: Object,
          default: () => {}
        },
        contract: {
          type: [String, Number]
        },
        orderTypeCode: {
          type: [String, Number]
        },
      },
      components: {
        Swatches
      },
      data: () => ({
        // Add temporary data to show headers on load - https://github.com/buefy/buefy/issues/1691
        summary: {
          data: [
            {
              code_id: "",
              code: "",
              name: "",
              total: {
                valid: "",
                invalid: "",
                total: ""
              }
            }
          ],
          total: {
            valid: 0,
            invalid: 0,
            total: 0
          }
        },
        loading: false
      }),
      computed: {
        height() {
          // Card header height
          return this.mapHeight - 36;
        },
        canManageAssets() {
          return this.$store.getters["Auth/hasPermission"](
            "can manage assets"
          );
        }
      },
      created() {
        this.fetch();
      },
      methods: {
        async fetch() {
          if (!this.contract) return;

          this.loading = true;

          this.summary = await this.$options.assetService
            .summary({
              contract_ids: [this.contract] || undefined,
              orderType_code_ids: this.orderTypeCode ? [this.orderTypeCode] : undefined,
              include_archived: 1, // assuming this component is only being used in /assets-offline
            })
            .then(response => response.data);

          this.loading = false;
        },
        clear() {
          this.summary = {
            data: [
              {
                code_id: "",
                code: "",
                name: "",
                total: {
                  valid: "",
                  invalid: "",
                  total: ""
                }
              }
            ],
            total: {
              valid: 0,
              invalid: 0,
              total: 0
            }
          };
        },
        getColor(type) {
          return this.colors[type] || "#8ED274";
        },
        async changeColor(row, color) {
          try {
            await this.$options.codeService.updateAttribute(
              row.code_id,
              "asset_map_marker_color",
              { value: color }
            );

            this.$buefy.toast.open({
              message: "Color has been changed.",
              type: "is-info",
              position: "is-top-right"
            });

            this.$emit("color-changed", { type: row.code, color });
          } catch (err) {}
        }
      }
    };

</script>

<style lang="scss">

    .assets-offline-map-summary {
        .card-content {
            padding: 0;
            .b-table .table {
                border: none;
                thead th {
                    position: sticky;
                    top: 0;
                    background: #363636;
                    color: white;
                    z-index: 1;
                }
                tfoot th.dark {
                    background: #363636;
                    color: white;
                }
            }
        }
    }

</style>


// WEBPACK FOOTER //
// src/components/AssetsOfflineMapSummary.vue